import api from "../../../services/api";

export interface WholesaleEventByDate {
  id: number;
  title: string;
  description: string;
  source: string;
  channel:string;
  location: string;
  start_at: string;
  end_at: string;
}

export type EventsWholesaleMonthResponse = WholesaleEventByDate[];

export async function getWholesaleEventsMonthService(month: string): Promise<EventsWholesaleMonthResponse> {
  // month format: "2025-08" (YYYY-MM)
  const res = await api.get<EventsWholesaleMonthResponse>(`/api/key_points/wholesale/by-month?month=${month}`);
  return res.data;
}